module.exports = __webpack_public_path__ + "img/sb-mobile.b84bdddf.png";